/**
 * Sticky header: optional background as soon as the user scrolls down.
 * At scroll position ~top, inline styles are cleared so a transparent header stays clear.
 */
const HEADER_SHADOW =
  '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)';

/** Pixels past top before showing the bar (avoids bounce/jitter) */
const SCROLL_THRESHOLD = 8;

function getScrollTop() {
  return (
    window.scrollY ??
    document.scrollingElement?.scrollTop ??
    document.documentElement.scrollTop ??
    0
  );
}

function applyStickyHeaderScrollState(header, isScrolled) {
  header.classList.toggle('site-header--scrolled', isScrolled);

  if (isScrolled) {
    const v = getComputedStyle(header).getPropertyValue('--sticky-header-scroll-bg').trim();
    if (!v) {
      return;
    }
    header.style.setProperty('background-color', v, 'important');
    header.style.setProperty('box-shadow', HEADER_SHADOW, 'important');
  } else {
    header.style.removeProperty('background-color');
    header.style.removeProperty('box-shadow');
  }
}

function initStickyHeaderScrollBg() {
  const header = document.querySelector('.site-header--sticky[data-sticky-scroll-bg]');
  if (!header) {
    return;
  }

  let ticking = false;

  const update = () => {
    applyStickyHeaderScrollState(header, getScrollTop() > SCROLL_THRESHOLD);
    ticking = false;
  };

  const onScrollOrResize = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  update();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyHeaderScrollBg);
} else {
  initStickyHeaderScrollBg();
}
